import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-system-logo',
    standalone: true,
    imports: [],
    template: `
    <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.125 1H8.875C4.52576 1 1 4.52576 1 8.875V35.125C1 39.4742 4.52576 43 8.875 43H35.125C39.4742 43 43 39.4742 43 35.125V8.875C43 4.52576 39.4742 1 35.125 1Z"
        [attr.fill]="backgroundColor" />
      <path
        d="M5.54291 13.6H18.3689L18.6549 18.198H17.5769C16.9829 15.558 16.0369 14.722 13.0229 14.722H11.1089V20.64H12.2529C13.9029 20.64 14.2109 20.112 14.6289 18.066H15.4869V24.358H14.6289C14.2329 22.246 13.8809 21.74 12.2529 21.74H11.1089V25.458C11.1089 27.592 11.6149 27.9 13.8149 27.988V29H5.54291V27.988C7.28092 27.834 7.65491 27.394 7.65491 25.458V17.142C7.65491 15.14 7.23691 14.766 5.54291 14.612V13.6ZM38.927 28.076V29H32.877V28.076C33.757 28.01 34.065 27.658 34.065 26.69V21.74C34.065 20.42 33.603 19.694 32.503 19.694C31.689 19.694 31.051 20.112 30.765 20.882V26.624C30.765 27.746 31.007 27.988 31.931 28.076V29H26.365V28.076C27.179 28.01 27.531 27.724 27.531 26.932V21.74C27.531 20.442 27.069 19.694 26.013 19.694C25.111 19.694 24.495 20.31 24.231 20.948V26.844C24.231 27.768 24.517 27.988 25.397 28.076V29H19.369V28.076C20.667 27.988 21.019 27.68 21.019 26.624V20.926C21.019 20.222 20.601 20.024 19.963 20.024C19.743 20.024 19.523 20.046 19.303 20.068V19.144L22.889 17.912H23.989V19.188C23.989 19.694 23.857 20.2 23.703 20.728L23.857 20.772C24.517 18.814 25.771 17.648 27.641 17.648C29.203 17.648 30.325 18.418 30.655 20.09H30.765C31.381 18.506 32.525 17.648 34.131 17.648C36.089 17.648 37.299 18.858 37.299 21.234V26.536C37.299 27.68 37.717 27.988 38.927 28.076Z"
        [attr.fill]="foregroundColor" />
    </svg>
  `,
    styles: [`
    :host {
      display: inline-block;
      line-height: 0;
    }
  `]
})
export class SystemLogoComponent {
    @Input() size: number = 44;
    @Input() backgroundColor: string = '#7EA6CB';
    @Input() foregroundColor: string = '#181A18';
}
